import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=3dd2a613&scoped=true&"
import script from "./Todo.vue?vue&type=script&lang=js&"
export * from "./Todo.vue?vue&type=script&lang=js&"
import style0 from "./Todo.vue?vue&type=style&index=0&id=3dd2a613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2a613",
  null
  
)

export default component.exports